import './PageNotFound.scss'
import * as React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { Elements } from '@tfo/common'
const { Paragraph, Heading4 } = Elements

const PageNotFound: React.FunctionComponent<WrappedComponentProps> = (
	props: WrappedComponentProps,
) => {
	return (
		<div className="PageNotFound">
			<div className="PageNotFoundHeader">
				<Heading4>
					{props.intl.formatMessage({ id: 'common.page-not-found.header' })}
				</Heading4>
				<Paragraph>
					{props.intl.formatMessage({ id: 'common.page-not-found.body' })}
				</Paragraph>
			</div>
		</div>
	)
}

export default injectIntl(PageNotFound)
